// Small counts reconcile even when SSE appears healthy: an event can be lost
// during startup or a worker reconnect. Heavy result/list queries stay event-led.
export const ACTION_BADGE_RECONCILE_MS = 60_000;
export const actionBadgeQueryOptions = {
  staleTime: 15_000,
  refetchInterval: ACTION_BADGE_RECONCILE_MS,
  refetchIntervalInBackground: false,
  refetchOnWindowFocus: "always" as const,
  refetchOnReconnect: "always" as const,
};
